<template>
  <div
    v-if="feeds.length"
    class="FeedPins"
    role="navigation"
    :aria-label="$t('nav.pinned_feeds')"
  >
    <router-link
      v-for="item in feeds"
      :key="item.name"
      v-slot="{ href, navigate, isExactActive }"
      :to="item.to"
      custom
    >
      <a
        :href="href"
        class="button-unstyled feed-pin"
        :class="{ '-active': isCurrent(item, isExactActive) }"
        :aria-current="isCurrent(item, isExactActive) ? 'page' : undefined"
        :title="item.labelRaw || $t(item.label)"
        :aria-label="item.labelRaw || $t(item.label)"
        @click="navigate"
      >
        <FAIcon
          v-if="item.icon"
          fixed-width
          :icon="item.icon"
        />
        <img
          v-else-if="item.iconEmojiUrl"
          class="feed-pin-emoji"
          :src="item.iconEmojiUrl"
          alt=""
        >
        <span
          v-else
          class="feed-pin-letter"
        >{{ item.iconEmoji || item.iconLetter }}</span>
      </a>
    </router-link>
  </div>
</template>

<script src="./feed_pins.js"></script>

<style lang="scss">
/* a div, not a nav: nav elements are styled as the top bar */
.FeedPins {
  /* whole icons: the header's title gives way first */
  flex: none;
  display: flex;
  align-self: center;
  align-items: center;
  gap: 0.15em;
  font-size: 1rem;

  .feed-pin {
    display: inline-grid;
    place-items: center;
    width: 2.2em;
    height: 2.2em;
    border-radius: var(--r-item);

    --icon: var(--textFaint);

    color: var(--icon);

    &:hover,
    &:focus-visible {
      --icon: var(--text);
    }

    &:focus-visible {
      outline: 2px solid color-mix(in oklab, var(--accent) 70%, transparent);
    }

    &.-active {
      --icon: var(--link);
    }
  }

  .feed-pin-letter {
    font-weight: 700;
  }

  .feed-pin-emoji {
    width: 1.25em;
    height: 1.25em;
    object-fit: contain;
  }
}
</style>
